import { Instance } from 'mobx-state-tree';
import model from './model';
import views from './views';

const Breakpoint = model.views(views);

export interface IBreakpoint extends Instance<typeof Breakpoint> {}

export default Breakpoint;
